import { atom } from 'jotai';

export interface RecordWalker {
  checkRecord(recordId: string): boolean;
  nextRecord(recordId: string): string | null;
  prevRecord(recordId: string): string | null;
}

export const recordWalkerByCollectionViewId = atom<Record<string, RecordWalker>>({});
